import * as Yup from 'yup';
export const initialRaceValues = {
    description: '',
    enumId: '',
};
export const raceSchema = Yup.object().shape({
    description: Yup.string(),
});
//# sourceMappingURL=race.js.map